<script>
import * as R from 'ramda'

export default {
  data() {
    return {
      model: { domain: '' },
      ui: { disabled: false },
    }
  },
  watch: {
    'model.domain'(domain) {
      if (domain.startsWith('http://')) {
        this.model.domain = R.pipe(
          R.split('http://'),
          R.last,
        )(domain)
      } else if (domain.startsWith('https://')) {
        this.model.domain = R.pipe(
          R.split('https://'),
          R.last,
        )(domain)
      } else if (domain.startsWith('.')) {
        this.model.domain = R.pipe(
          R.split('.'),
          R.tail,
          R.join('.')
        )(domain)
      } else if (domain.includes('/')) {
        this.model.domain = domain.replace(/\//g, '')
      } else if (/\s/.test(domain)) {
        this.model.domain = domain.replace(/\s/g, '')
      }
    },
    '$store.state.ui.bitrixLoginModal': {
      handler(isOpen) {
        if (isOpen) {
          this.focus()
        }
      },
      immediate: true,
    },
  },
  created() {
    window.addEventListener('message', this.windowMessageListener, false)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.windowMessageListener, false)
  },
  methods: {
    enter() {
      const { $store, ui, model: { domain } } = this
      if (ui.disabled || !domain) return

      ui.disabled = true
      $store.dispatch('auth/bitrixLogIn', { domain })
        .then(({ url, popup }) => {
          if (popup) {
            const width = 1100
            const height = 800
            const left = (screen.width / 2) - (width / 2)
            const top = (screen.height / 2) - (height / 2)
            const popup = window.open(
              url, 'popup',
              `width=${width},height=${height},left=${left},top=${top},toolbar=0,menubar=0,location=0`,
            )
            if (popup.focus) { popup.focus() }
          } else {
            window.open(url, '_blank')
          }
        })
        .finally(() => { this.ui.disabled = false })
        .catch(e => {
          console.error(e)
        })
    },
    windowMessageListener(event) {
      const msg = event.data
      switch (msg && msg.type) {
        case 'bitrixOauthRedirect':
          window.top.location = msg.url
          break
        default:
          if (process.env.NODE_ENV === 'production') {
            console.error(`unknown message: ${msg && msg.type}`)
          }
      }
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.domain.focus()
        setTimeout(() => this.$refs.domain.focus(), 200)
      })
    },
  },
}
</script>

<template>
  <VDialog
    :value="$store.state.ui.bitrixLoginModal"
    persistent
    width="500"
    @input="$store.commit('ui/setBitrixLoginModal', { value: $event })"
  >
    <VCard
      class="mx-auto"
      max-width="500"
    >
      <VCardTitle class="title font-weight-regular justify-space-between">
        <span>Войти через Битрикс24</span>
      </VCardTitle>

      <VCardText>
        <VTextField
          ref="domain"
          v-model="model.domain"
          placeholder="mycompany.bitrix24.ru"
          autofocus
          :disabled="ui.disabled"
          @keydown.enter="enter()"
          @keydown.tab.prevent="enter()"
        />
        <span class="caption grey--text text--darken-1">
          Домен портала Битрикс24
        </span>
      </VCardText>

      <VCardActions>
        <VBtn
          :disabled="ui.disabled"
          text
          @click="$store.commit('ui/setBitrixLoginModal', { value: false })"
          v-text="'Отмена'"
        />
        <VSpacer />
        <VBtn
          :disabled="ui.disabled || !model.domain"
          :loading="ui.disabled"
          color="primary"
          depressed
          @click="enter()"
          v-text="'Войти'"
        />
      </VCardActions>
    </VCard>
  </VDialog>
</template>
